import { render } from "./PaginationComp.vue?vue&type=template&id=33e7df29"
import script from "./PaginationComp.vue?vue&type=script&lang=js"
export * from "./PaginationComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__